<template>
    <b-container class="container-panel">
        <LanguageSelection></LanguageSelection>
        <b-card no-body id="reverse-view">
            <b-card-body>
                <b-card-header><h4>{{$t('REVERSIBLE_PAYMENTS')}} ({{ payments.length }})</h4></b-card-header>
                <b-container>
                    <b-row class="record">
                        <b-col cols="1" class="text-right">
                            <b-button @click="previousPage()" :disabled="disablePreviousPage"><</b-button>
                        </b-col>
                        <b-col cols="2" class="text-center">
                            <b-form-select v-model="paymentPageIndex" :options="paymentPageIndexes"></b-form-select>
                        </b-col>
                        <b-col cols="1" class="text-left">
                            <b-button @click="followingPage()" :disabled="disableFollowingPage">></b-button>
                        </b-col>
                        <b-col cols="1" class="text-center">
                            <b-form-select v-model="paymentPageSize" :options="paymentPageSizes"></b-form-select>
                        </b-col>
                        <b-col cols="5"></b-col>
                        <b-col cols="2" class="text-center">
                            <b-button @click="refresh">{{$t('REFRESH')}}</b-button>
                        </b-col>
                    </b-row>
                    <b-row class="record">
                        <b-col cols="4"><strong>{{$t('REVERSIBLE_PAYMENT_DATE')}}</strong></b-col>
                        <b-col cols="2"><strong>{{$t('REVERSIBLE_AMOUNT')}}</strong></b-col>
                        <b-col cols="4"><strong>{{$t('REVERSIBLE_TRANSACTION_REFERENCE_NUMBER')}}</strong></b-col>
                        <b-col cols="2"><strong>{{$t('REVERSE')}}</strong></b-col>
                    </b-row>
                    <b-row class="record" v-for="p in paymentPage" v-bind:key="p.paymentId" >
                        <b-col cols="4">{{formatDate(p.paymentDate)}}</b-col>
                        <b-col cols="2">{{formatDollar(p.amount)}}</b-col>
                        <b-col cols="4">{{p.transactionReferenceNumber}}</b-col>
                        <b-col cols="2" ><b-button @click="confirm(p)" class="btn-info">{{$t('REVERSE')}}</b-button></b-col>
                    </b-row>
                    <b-row class="record">
                    </b-row>
                </b-container>
            </b-card-body>
        </b-card>

        <br /><br />

        <b-card no-body id="reverse-confirm" v-bind:style="{ display: confirmPayment.display }">
            <b-card-body>
                <b-card-header><h4>{{ confirmMessage }}</h4></b-card-header>
                <b-form @submit.stop.prevent>
                    <b-container>
                        <b-row>
                            <b-col cols="8">
                                <b-form-input 
                                    v-model="confirmPayment.amount"
                                    type="number"
                                    step="0.01"
                                    :placeholder="confirmPlaceholder"
                                    :min="confirmMin"
                                    :max="confirmMax"
                                    :formatter="formatReversalAmount"
                                    :disabled="disablePartialReverse"
                                    >
                                </b-form-input>
                            </b-col>
                            <b-col cols="2"><b-button class="btn-danger" @click="submit">{{$t('SUBMIT')}}</b-button></b-col>
                            <b-col cols="2"><b-button @click="close">{{$t('CLOSE')}}</b-button></b-col>
                        </b-row>
                    </b-container>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
    import { mapActions, mapGetters, mapState } from "vuex";
    import i18n from '../localization';
    import LanguageSelection from '../components/LanguageSelection.vue';
    import Repo from '../repo';

    export default {
        name: "ReversePayment",
        components: { LanguageSelection },
        data: () => ({
            paymentPageIndex: 0,
            paymentPageSize: 5,
            paymentPageSizes: [
                { value: 5, text: '5' },
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 50, text: '50' },
                { value: 100, text: '100' }
            ],
            confirmPayment: {
                paymentId: 0,
                paymentDate: new Date(),
                amount: 0.00,
                minimumReversibleAmount: 0.00,
                maximumReversibleAmount: 0.00,
                externalKeyType: '',
                externalKeyValue: '',
                externalReferenceNumber: '',
                transactionReferenceNumber: '',
                authToken: '',
                display: 'none'
            }
        }),
        computed: {
            ...mapState({
                payments: state => state.lobby.reversiblePayments
            }),
            confirmMin: function () {
                return this.confirmPayment ? this.confirmPayment.minimumReversibleAmount : 0.00;
            },
            confirmMax: function () {
                return this.confirmPayment ? this.confirmPayment.maximumReversibleAmount : 0.00;
            },
            confirmPlaceholder: function () {
                return `$ ${this.confirmMin} - ${this.confirmMax}`;
            },
            confirmMessage: function () {
                if ( this.confirmPayment) {
                    return `${i18n.t('REVERSE')} : ${this.confirmPayment.transactionReferenceNumber}`;
                }
                return '';
            },
            isValidAmount: function () {
                return this.confirmPayment.amount && !isNaN(this.confirmPayment.amount) && this.confirmPayment.amount <= this.confirmMax && this.confirmPayment.amount >= this.confirmMin;
            },
            disablePartialReverse: function () {
                return this.confirmMin === this.confirmMax;
            },
            disablePreviousPage: function () {
                return this.paymentPageIndex < 1;
            },
            disableFollowingPage: function () {
                return this.paymentPageIndex > this.paymentPageIndexes.length - 2;
            },
            paymentPageIndexes: function () {
                var a = [];
                for (let i = 0; i * this.paymentPageSize < this.payments.length; i++)
                    a.push({ value: i, text: i + 1 });
                return a;
            },
            paymentPage: function () {
                if (this.payments) {
                    let len = this.payments.length;

                    let start = (this.paymentPageIndex * this.paymentPageSize) >= len
                        ? len - 1
                        : (this.paymentPageIndex * this.paymentPageSize) < 0
                            ? 0
                            : (this.paymentPageIndex * this.paymentPageSize);

                    let end = start + this.paymentPageSize;

                    return this.payments.slice(start, end);
                } else {
                    return this.payments;
                }
            }
        },
        mounted() {
            this.updateLanguageFromQuery({
                lang: this.$route.query.lang
            });
            Repo.AuthenticationService.ValidateToken({ Token: this.$route.params.authToken })
                .then(res => {
                    if (res && res.success) {
                        this.setReversiblePaymentsFor({
                            ExternalKeyType: this.$route.params.externalKeyType,
                            ExternalKeyValue: this.$route.params.externalKeyValue
                        });
                    } else {
                        this.addErrorMessages({
                            error: i18n.t('NOT_AUTHENTICATED')
                        });
                        if (window.location.href.includes("localhost") || window.location.href.includes("int")) {
                            //this.$router.push('/');
                        } else {
                            this.$router.push('/');
                        }
                    }
                });
        },
        methods: {
            ...mapActions({
                setReversiblePaymentsFor: 'lobby/setReversiblePaymentsFor',
                processPaymentReversal: 'lobby/processPaymentReversal',
                addErrorMessages: 'shell/addErrorMessages',
                addErrorHTML: 'shell/addErrorHTML',
                updateLanguageFromQuery: 'shell/updateLanguageFromQuery'
            }),
            ...mapGetters({
                reversiblePayments: 'lobby/reversiblePayments'
            }),
            confirm: function (payment) {
                console.log('confirming payment reversal...', payment.minimumReversibleAmount, payment.amount );

                if (payment) {
                    this.confirmPayment = {
                        paymentId: payment.paymentId,
                        paymentDate: payment.paymentDate,
                        amount: payment.amount,
                        minimumReversibleAmount: payment.minimumReversibleAmount,
                        maximumReversibleAmount: payment.amount,
                        externalKeyType: this.$route.params.externalKeyType,
                        externalKeyValue: this.$route.params.externalKeyValue,
                        externalReferenceNumber: payment.externalReferenceNumber,
                        transactionReferenceNumber: payment.transactionReferenceNumber,
                        authToken: this.$route.params.authToken,
                        display: ''
                    }
                } else {
                    this.addErrorMessages({
                        error: i18n.t('REVERSE_INVALID')
                    });
                }
            },
            close: function () {
                console.log('closing payment reversal...');

                this.confirmPayment = {
                    paymentId: 0,
                    paymentDate: null,
                    amount: 0.00,
                    minimumReversibleAmount: 0.00,
                    maximumReversibleAmount: 0.00,
                    externalKeyType: '',
                    externalKeyValue: '',
                    externalReferenceNumber: '',
                    transactionReferenceNumber: '',
                    authToken: '',
                    display: 'none'
                };
            },
            followingPage: function () {
                if (this.paymentPageIndex + 1 < this.paymentPageIndexes.length) this.paymentPageIndex = this.paymentPageIndex + 1;
            },
            formatDollar: function (n) {
                let formatter = new Intl.NumberFormat(i18n.t('LOCALE_CODE'), {
                    style: 'currency',
                    currency: 'USD',
                });
                return formatter.format(n);
            },
            formatDate: function (d) {
                let formatter = new Intl.DateTimeFormat(i18n.t('LOCALE_CODE'), {
                    timeZoneName: 'short',
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                })
                return formatter.format(new Date(d));
            },
            previousPage: function () {
                if (this.paymentPageIndex > 0) this.paymentPageIndex = this.paymentPageIndex - 1;
            },
            submit: async function () {
                console.log('submitting payment reversal', this.confirmPayment);

                if (this.confirmPayment && this.isValidAmount && this.confirmPayment.paymentId) {
                    Repo.HostedPaymentService.ProcessPaymentReversal({
                        PaymentId: this.confirmPayment.paymentId,
                        Amount: this.confirmPayment.amount,
                        ExternalKeyType: this.$route.params.externalKeyType,
                        ExternalKeyValue: this.$route.params.externalKeyValue,
                        Token: this.$route.params.authToken
                    })
                        .then(res => {
                            console.log('submission result', res);
                            if (res && !res.error && res.status != 'Error') {
                                // alert user
                                alert(i18n.t('REVERSE_SUCCESS'));
                                // change page if necessary
                                if (this.paymentPageIndex > this.paymentPageIndexes.length - 1) this.paymentPageIndex = this.paymentPageIndex - 1;
                                // close confirmation window
                                this.close();
                                // refresh data
                                this.refresh();
                            }
                            else {

                                // Traverse errors dictionairy and display to user
                                var chaseErrorMsg = '<br><br>Payment Processor Error Response:';

                                if (res && res.data && res.data.errors) {
                                    for (let key in res.data.errors) {
                                        chaseErrorMsg = chaseErrorMsg +
                                            '<br>' +
                                            key + ': <b>' +
                                            res.data.errors[key] + '</b>';
                                    }
                                }
                                else {
                                    chaseErrorMsg = '';
                                }

                                console.log('payment reversal errors', chaseErrorMsg);

                                this.addErrorHTML(i18n.t('REVERSIBLE_ERROR_PROCESS') 
                                                  + chaseErrorMsg);
                            }
                        });
                } else {
                    this.addErrorMessages({
                        error: i18n.t('REVERSIBLE_ERROR_INVALID_AMOUNT')
                    });
                }

            },
            refresh: async function () {
                this.setReversiblePaymentsFor({
                    ExternalKeyType: this.$route.params.externalKeyType,
                    ExternalKeyValue: this.$route.params.externalKeyValue
                });
            },
            formatReversalAmount: function (val, event) {
                var formatter = new Intl.NumberFormat(i18n.t('LOCALE_CODE'), {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                });
                // remove non-number characters
                let clean = val.replace(/[^0-9,\.]/g, '');
                // don't allow not-a-number values
                if (isNaN(clean)) return formatter.format(this.confirmMax);
                // don't allow less than min
                if (this.confirmMin > clean) return formatter.format(this.confirmMin);
                // don't allow more than max
                if (this.confirmMax < clean) return formatter.format(this.confirmMax);
                // don't allow extra decimal places
                var formatted = formatter.format(clean);
                if (formatted.length < clean.length) {
                    // truncate, don't round spammed extra decimal digits
                    if (formatted > clean) {
                        return formatted - 0.01
                    }
                    return formatted;
                }
                return clean;
            }
        }
    }
</script>

<style>
    .record {
        padding-top:15px;
    }
</style>